import { GetPartFinderBatchResponse } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { AxiosApiError } from '@/types/apiError';
import { Query, useQuery } from '@tanstack/react-query';
import { PART_FINDER_BATCH_QUERY_KEY } from './query';

export const useGetPartFinderBatch = (
  id: string,
  options?: {
    refetchInterval?: number | false | ((query: Query<GetPartFinderBatchResponse, AxiosApiError>) => number | false);
  }
) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  return useQuery<GetPartFinderBatchResponse, AxiosApiError>({
    queryKey: [PART_FINDER_BATCH_QUERY_KEY, id],
    queryFn: async () => {
      const response = await api.tenants.getPartFinderBatch(tenantId, id);
      return response.data;
    },
    enabled: !!id && !!tenantId,
    refetchInterval: options?.refetchInterval,
  });
};
